module.exports = __webpack_public_path__ + "img/ico-map.619be433.svg";